(function() {

	//Remember if the menu is opened or not
	var menuOpened = false;
	var menuButtonOpen = document.querySelector('.site-navigation-icon-menu');
	var menuButtonClose = document.querySelector('.site-navigation-icon-close');
	var navigationContainer = document.querySelector('.site-navigation-holder');
	var siteNavigationHolder = document.querySelector('.navigation');
	var siteContainer = document.querySelector('.main-contentcollection-wrapper');
	var body = document.querySelector('body');
	var footerContainer = document.querySelector('.footer');

	if(!menuButtonOpen || !menuButtonClose || !navigationContainer) {
		return;
	}

	// Add click listener on menu icon
	menuButtonOpen.addEventListener('click', onMenu_click);
	menuButtonClose.addEventListener('click', onMenu_click);
	// Add click listener on menu 
	navigationContainer.addEventListener('click', onnavigationContainer_click);

	function toggleMenu(){
		menuOpened = !menuOpened;
		var navigationContainerHeight = navigationContainer.offsetHeight; 

		if (menuOpened) {
			body.classList.add('menu-is-open');
		} else {
			body.classList.remove('menu-is-open');
		}
	}

	function onMenu_click(domEvent){
		domEvent.stopPropagation();
		toggleMenu();
	}

	function onnavigationContainer_click(domEvent){
		domEvent.stopPropagation();

		if (menuOpened) {
			toggleMenu();
		}
	}


}());
